/* global __SERVER__ */

import React, { PureComponent } from 'react';
import { asyncConnect } from 'redux-connect';
import { connect } from 'react-redux';

import { fetchEvents, fetchOrganiser } from '../../state/actions';
import { trackPageVisit } from '../../utils/tracking';
import {
  getOrganiserSelectedError,
  getOrganiser,
  getOrganiserSelectedFetching,
} from '../../state/reducers';

import OrganiserDetailPage from '../../components/OrganiserDetailPage';

const getSearchQuery = organiserId => ({ organiser: organiserId, sort: 'date' });

/**
 * Organiser detail page container.
 * Wraps the organiser detail page presentational component with Redux state.
 * Adds props to component representing fetch state and organiser object result.
 */
class OrganiserDetailPageContainer extends PureComponent {
  componentWillMount() {
    // If the error has a status code, overwrite the route
    const { error, route } = this.props;
    if (error && error.status) {
      route.status = error.status;
    }
  }

  componentDidMount() {
    const { organiser, router, location } = this.props;
    // Push the organiser slug to the URL if it's absent
    if (organiser && !router.params.organiserSlug) {
      router.replace(`${organiser.permalink}${location.search}${location.hash}`);
    }
    if (organiser) {
      trackPageVisit('Organiser');
    }
  }

  render() {
    return (
      <OrganiserDetailPage
        {...this.props}
        searchQuery={getSearchQuery(this.props.organiserId)}
      />
    );
  }
}

OrganiserDetailPageContainer.propTypes = OrganiserDetailPage.propTypes;

// Selectors are used so state shape is encapsulated within reducers
const mapStateToProps = (state, { params: { organiserId } }) => ({
  error: getOrganiserSelectedError(state),
  organiser: getOrganiser(state, organiserId),
  organiserId,
  fetching: getOrganiserSelectedFetching(state),
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const OrganiserDetailPageWithConnect = connect(mapStateToProps)(OrganiserDetailPageContainer);

// Configure promises that must be fulfilled before the component is rendered, e.g. fetch event data
export const asyncPromises = [{
  promise: ({ params, store: { dispatch } }) => {
    const action = new Promise((resolve, reject) => {
      dispatch(fetchOrganiser(params.organiserId))
        .then((response) => {
          if (!(response && response.value)) {
            reject('No organiser found');
            return;
          }
          dispatch(fetchEvents(getSearchQuery(params.organiserId)))
            .then(values => resolve(values))
            .catch(e => reject(e));
        }).catch(e => reject(e));
    });

    return __SERVER__ ? action : Promise.resolve();
  },
}];

// Wrap in [redux-connect](https://github.com/makeomatic/redux-connect)
const OrganiserDetailPageContainerWithAsync =
  asyncConnect(asyncPromises)(OrganiserDetailPageWithConnect);

export default OrganiserDetailPageContainerWithAsync;



// WEBPACK FOOTER //
// ./app/src/containers/OrganiserDetailPage/index.jsx